export default __webpack_public_path__ + "static/media/img2.0ea6b54f.jpg";